import { NFTTYPE } from '../constants/bakery/nft'

export function userBakeContractVersion(type?: string) {
  let version = 'v1'
  switch (type) {
    case NFTTYPE.COMBO_V3:
    case NFTTYPE.SOCCER_V3:
    case NFTTYPE.POKER_V3:
    case NFTTYPE.CAR_V3:
    case NFTTYPE.DOGGIES_V3:
    case NFTTYPE.BARKING_V3:
    case NFTTYPE.EQUIPMENT_V3:
    case NFTTYPE.BAKEMUSKMIXER_V3:
      version = 'v2'
      break
  }
  return version
}
